module.exports = __webpack_public_path__ + "VIPH18.png?6012d14137bc0b4f684f51e6425523cc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH18.png
// module id = 90
// module chunks = 0